// extracted by mini-css-extract-plugin
module.exports = {"container":"CampaignParticipationManual_container__1BW77"};